import { cn } from "@repo/blacksmith-ui/cn";

/** `1234` → `"1,234"`, the grouping every diff count uses. */
export function formatLineCount(count: number): string {
  return count.toLocaleString("en-US");
}

/** Line counts as `+1,234 -141`; a side with nothing to count is left out, and none at all renders nothing. */
export function LineCounts({
  additions,
  deletions,
  className,
}: {
  additions: number;
  deletions: number;
  className?: string;
}) {
  if (additions === 0 && deletions === 0) return null;
  return (
    <span className={cn("shrink-0 tabular-nums", className)}>
      {additions > 0 && (
        <span className="text-ds-diff-added">
          +{formatLineCount(additions)}
        </span>
      )}
      {additions > 0 && deletions > 0 && " "}
      {deletions > 0 && (
        <span className="text-ds-diff-removed">
          -{formatLineCount(deletions)}
        </span>
      )}
    </span>
  );
}
